import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import CloudProHeader from './CloudProHeader';
import "../Styles/UserManagement.css";
import { useParams } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
const CloudProMdLogs = () => {
    const [logs, setLogs] = useState([]);
    const { mdId } = useParams();
    const siId = localStorage.getItem("siId"); // set once during login / selection

    const fetchLogs = () => {
        Axios.post(`/get_customer_logs`, {mdId, siId})
            .then((response) => {
                if (response.data.success) {
                    setLogs(response.data.logs || []);
                } else {
                    toast.error("Failed to get logs.", { position: "top-right" });
                }
            })
            .catch(() => {
                toast.error("Error fetching logs.", { position: "top-right" });
            });
    };

    useEffect(() => {
        fetchLogs();
    }, []);

    return (

<>

 <div className="project-container">
         <CloudProHeader isAdmin={true} />
        <div className="glass-card">

          <Card sx={{ minWidth: 275 }}>
            <CardContent>
              <div className="header">
                <div className="left-actions">
                  <h3>Logs</h3>
                </div>
                <div className="button-row">
                    <button onClick={fetchLogs} className="refresh-button">Refresh</button>
                </div>
              </div>
 
              <table className="project-table">
                
                <thead>
                  <tr>
                  <th style={{ width: "5%" }}>#</th>
                                <th style={{ width: "15%" }}>Operator Email</th>
                                <th style={{ width: "10%" }}>First Name</th>
                                <th style={{ width: "10%" }}>Last Name</th>
                                <th style={{ width: "47%" }}>Message</th>
                                <th style={{ width: "13%" }}>Time</th>
                  </tr>
                </thead>
                <tbody>
                            {(logs || []).map((log, index) => (
                                <tr key={log.id}>
                                    <td>{index + 1}</td>
                                    <td>{log.operator_email}</td>
                                    <td>{log.first_name}</td>
                                    <td>{log.last_name}</td>
                                    <td>{log.log_message}</td>
                                    <td>{new Date(log.operation_time).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                </table>
                </CardContent></Card>
                </div>
</div>

        
     
        </>
    );
};

export default CloudProMdLogs;
